import React from 'react';
import VoxelAlert from '../../../components/voxel/Alert/VoxelAlert';
import VoxelDialog from '../../../components/voxel/Dialogs/VoxelDialog';
import VoxelDialogActionButton from '../../../components/voxel/Dialogs/VoxelDialogActionButton';
import VoxelDialogContent from '../../../components/voxel/Dialogs/VoxelDialogContent';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import { AppTierTypeGq } from '../../../graphql/projects/models/AppTierTypeGq';
import { CurrentTeamGq } from '../../../graphql/users/models/CurrentTeamGq';
import VoxelDialogActions from '../../../components/voxel/Dialogs/VoxelDialogActions';

export interface NewConnectionDialogStartProps {
  close: () => void;
  shareTeamData: () => void;
  requestAccessToTeamData: () => void;
  team: CurrentTeamGq;
  minWidth: string;
}

export const NewConnectionDialogStart: React.FC<NewConnectionDialogStartProps> = ({
  close,
  shareTeamData,
  requestAccessToTeamData,
  team,
  minWidth,
}) => {
  const requestsEnabled = [
    AppTierTypeGq.BETA_BASIC,
    AppTierTypeGq.BETA_CUSTOM,
    AppTierTypeGq.BASIC,
    AppTierTypeGq.CUSTOM,
  ].includes(team.appTier.tierType);

  const userHasAccess = team.accessUserCanEditTeamConnections;

  return (
    <VoxelDialog open onClose={close} closeOnBackdrop title="New team connection">
      {!userHasAccess && (
        <VoxelDialogContent>
          <VoxelAlert>You don't have permission to edit your team's connections</VoxelAlert>
        </VoxelDialogContent>
      )}
      {userHasAccess && (
        <>
          <VoxelDialogContent classMinWidth={minWidth}>
            <VoxelText>What type of connection do you want?</VoxelText>
          </VoxelDialogContent>
        </>
      )}
      <VoxelDialogActions gridCols="grid-cols-2">
        <VoxelDialogActionButton
          color="primary"
          className="w-full"
          title="Share my team's project data"
          onClick={shareTeamData}
          disabled={!userHasAccess}
          size="xl"
          fullWidth
        />
        <span className="relative flex flex-col items-center justify-start">
          <VoxelDialogActionButton
            className="w-full"
            color="primary"
            title={`Request other team's project data`}
            onClick={requestAccessToTeamData}
            disabled={!requestsEnabled || !userHasAccess}
            size="xl"
            fullWidth
          />
          <VoxelText variant="form-caption" paddingTop>
            (paid plans only)
          </VoxelText>
        </span>
      </VoxelDialogActions>
    </VoxelDialog>
  );
};

export default NewConnectionDialogStart;
